import { selectedEntityIds } from '../../../../shared/utils/entitySelection';
export function resolveDealResponsible(deal, staff = []) {
  const staffId = deal?.staffId ?? deal?.assigneeStaffId ?? deal?.assignedStaffId ?? deal?.linkedStaffId ?? null;
  const linkedStaff = staffId === null || staffId === undefined || staffId === ''
    ? null
    : staff.find((member) => String(member.id) === String(staffId));
  const ids = selectedEntityIds(deal, 'staff');
  const label = ids.length > 1 ? ids.map((id) => staff.find((member) => String(member.id) === id)?.name || `Staff #${id}`).join('; ') : linkedStaff?.name || deal?.assignee || 'N/A';

  return {
    label,
    staffId,
    staffMember: linkedStaff || null,
    hasLinkedStaff: Boolean(linkedStaff),
    hasMissingStaffReference: Boolean(staffId) && !linkedStaff,
    hasLegacyAssignee: !linkedStaff && !staffId && Boolean(deal?.assignee),
  };
}
